<template>
    <div class="animated fadeIn">
        <BaseInventory
            categoryId="15"
            categoryName="Sand Trapper"
            categorySectionIcon="fa-wrench"
        />
    </div>
</template>

<script>
import BaseInventory from './base/BaseInventory'

export default {
    name: 'sand-trapper',
    components: { BaseInventory }
}
</script>
